module.exports = __webpack_public_path__ + "img/16-blog-send-message.4a82f062.webp";